export function getEnvironmentCommonName(environment: { region: string, environment: string }): string {
  if (environment.region === 'us-east-1') {
    return environment.environment
  }

  return `${environment.environment}-${environment.region}`
}
